module.exports = __webpack_public_path__ + "img/P1070888.3a162bd6.jpg";